import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { fontRobotoCondensed } from "@product/scmp-sdk";

export const Container = styled.div`
  max-inline-size: 1208px;
  margin: auto;
`;

export const Header = styled.div`
  inline-size: 100%;
  padding-block-start: 24px;
  padding-block-end: 16px;

  font-weight: 700;
  font-size: 16px;
  font-family: ${fontRobotoCondensed};
  line-height: 22px;
  text-transform: uppercase;

  ${props => props.theme.breakpoints.up("tablet")} {
    padding-block-start: 28px;

    font-size: 18px;
    line-height: 25px;
  }

  ${props => props.theme.breakpoints.only("mobile")} {
    padding: 0;
  }
`;

export const Grid = styled.div`
  display: grid;
  grid-auto-rows: min-content;
  grid-template-columns: 1fr;
  grid-row-gap: 28px;

  inline-size: 100%;

  ${props => props.theme.breakpoints.only("mobile")} {
    grid-gap: 0;
  }
`;

type RowProps = {
  $columns: number;
};
export const Row = styled.div<RowProps>`
  display: grid;
  grid-column-gap: 24px;

  inline-size: 100%;

  ${props => css`
    grid-template-columns: repeat(${props.$columns}, 1fr);
  `}
`;
